<div *ngIf="containerDisplay === 'LIST'">
    <div class="page-sub-title">Players</div>
    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th class="hide-on-mobile">Email</th>
            <th class="hide-on-mobile">Phone</th>
            <th class="center"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of allPlayers">
            <td>
              {{ p.firstName }} {{ p.lastName }}
            </td>
            <td class="hide-on-mobile">
              {{ p.email }}
            </td>
            <td class="hide-on-mobile">
              {{ p.phone }}
            </td>
            <td class="center">
                <img src="../../../../assets/noun-pencil-8209025-FFFFFF.png" (click)="playerToUpdate = p; containerDisplay = 'UPDATE'" class="pencil"/>
            </td>
          </tr>
        </tbody>
        </table>
    </div>
    <button (click)="containerDisplay = 'CREATE'">Create Player</button>
</div>

<div *ngIf="containerDisplay === 'CREATE'">
    <div class="page-sub-title">Create Player</div>
    <form #form="ngForm" class="form">
        <div class="field">
            <input type="text" name="firstName" required [(ngModel)]="createPlayerRequest.firstName" #firstNameModel="ngModel" name="firstName" placeholder=" " />
            <label>First Name</label>
            <span class="error" *ngIf="firstNameModel.invalid && firstNameModel.touched">
                First is required
            </span>
        </div>
        <div class="field">
            <input type="text" name="lastName" required [(ngModel)]="createPlayerRequest.lastName" #lastNameModel="ngModel" placeholder=" "
            />
            <label>Last Name</label>
            <span class="error" *ngIf="lastNameModel.invalid && lastNameModel.touched">
                Last name is required
            </span>
        </div>
        <div class="field">
            <input type="email" name="email" [(ngModel)]="createPlayerRequest.email" #emailModel="ngModel" placeholder=" "/>
            <label>Email</label>
            <span class="error" *ngIf="emailModel.invalid && emailModel.touched">
                Invalid email address
            </span>
        </div>
        <div class="field">
            <input type="tel" name="phoneNumber" maxlength="10" inputmode="numeric" pattern="[0-9]*" [(ngModel)]="createPlayerRequest.phone" #phoneModel="ngModel" placeholder=" " (input)="onPhoneInput()" />
            <label>Phone Number</label>
            <span class="error" *ngIf="phoneModel.invalid && phoneModel.touched">
                Invalid phone. 10 digits required, numbers only.
            </span>
        </div>
        <button (click)="createNewPlayer()">Save</button>
        <button (click)="containerDisplay = 'LIST'" class="cancel">Cancel</button>
    </form>
</div>

<div *ngIf="containerDisplay === 'UPDATE'">
    <div class="page-sub-title">Update Player</div>
    <form #form="ngForm" class="form">
        <div class="field">
            <input type="text" name="firstName" required [(ngModel)]="playerToUpdate.firstName" #firstNameModel="ngModel" name="firstName" placeholder=" " />
            <label>First Name</label>
            <span class="error" *ngIf="firstNameModel.invalid && firstNameModel.touched">
                First is required
            </span>
        </div>
        <div class="field">
            <input type="text" name="lastName" required [(ngModel)]="playerToUpdate.lastName" #lastNameModel="ngModel" placeholder=" "
            />
            <label>Last Name</label>
            <span class="error" *ngIf="lastNameModel.invalid && lastNameModel.touched">
                Last name is required
            </span>
        </div>
        <div class="field">
            <input type="email" name="email" [(ngModel)]="playerToUpdate.email" #emailModel="ngModel" placeholder=" "/>
            <label>Email</label>
            <span class="error" *ngIf="emailModel.invalid && emailModel.touched">
                Invalid email address
            </span>
        </div>
        <div class="field">
            <input type="tel" name="phoneNumber" maxlength="10" inputmode="numeric" pattern="[0-9]*" [(ngModel)]="playerToUpdate.phone" #phoneModel="ngModel" placeholder=" " (input)="onPhoneInput()" />
            <label>Phone Number</label>
            <span class="error" *ngIf="phoneModel.invalid && phoneModel.touched">
                Invalid phone. 10 digits required, numbers only.
            </span>
        </div>
        <button (click)="updatePlayer()">Save</button>
        <button (click)="containerDisplay = 'LIST'" class="cancel">Cancel</button>
    </form>
</div>